import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import { getUserSettngs, updateUserData } from "../../Utils/userFunctions";
import { onlyNumber } from "../../Utils/commonFunctions";

let UserEditProfile = () => {
  const [uID, setUID] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [status, setStatus] = useState("");
  useEffect(() => {
    UserDetails();
  }, []);

  let UserDetails = async () => {
    const response = await getUserSettngs();
    if (response.status === "success") {
      setUID(response.data[0].user_id);
      setFirstName(response.data[0].first_name);
      setLastName(response.data[0].last_name);
      setContact(response.data[0].contact);
      setEmail(response.data[0].email);
      setCompany(response.data[0].company_name);
      setAddress1(response.data[0].address1);
      setAddress2(response.data[0].address2);
      setCity(response.data[0].city);
      setState(response.data[0].state_name);
      setCountry(response.data[0].country_name);
      setZipCode(response.data[0].zip_code);
      setStatus(response.data[0].status);
    }
  };
  const handleSubmit = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("contact", contact);
    bodyFormData.append("user_id", uID);
    bodyFormData.append("status", status);
    const response = await updateUserData(bodyFormData);
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
    }
    if (response.status == "failure") {
      toast.warning(response.message, { autoClose: 1500 });
    }
    if (response.status == "error") {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const phonNumberValidation = (number) => {
    const value = onlyNumber(number);
    setContact(value);
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <UserHeader />
      <div className="container">
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card vd-card">
              <div className="card-header">
                <div className="d-flex align-items-center">
                  <div className="mr-auto">
                    <h4 className="card-title">Edit Profile</h4>
                  </div>
                  <div className="profile-option-info">
                    <Link
                      to={"/UserDashboard/"}
                      className="btn btn-sm custom-btn-primary pull-right"
                    >
                      <i className="fa fa-arrow-left"></i> Back
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile-content-edit">
                      <h3 className="profile-heading">Personal</h3>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                First Name
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="First Name"
                                value={firstName}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Last Name
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                value={lastName}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Email
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Phone Number
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={contact}
                                onChange={(e) => {
                                  phonNumberValidation(e.target.value);
                                }}
                                maxLength={12}
                                placeholder="Contact No."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile-content-edit">
                      <h3 className="profile-heading">Company Information</h3>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Company Name
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Company Name"
                                value={company}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Address1
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Address1"
                                value={address1}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Address2
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Address2"
                                value={address2}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                City
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                value={city}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                State
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="State"
                                value={state}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Zip/Code
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Zip/Code"
                                value={zipCode}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Country
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Country"
                                value={country}
                                readOnly="readonly"
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <button
                      className="btn btn-primary mt-3 pull-right custom-btn-primary"
                      onClick={handleSubmit}
                    >
                      Update Profile
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserEditProfile;
